import React from "react";

export default function CookiePolicyPage() {

  return <iframe src="https://app.termly.io/policy-viewer/policy.html?policyUUID=2757be5f-88df-412c-a470-c9d43c875330"
                 width="100%"
                 height="3850px" />

}